<template>
  <div class="div" v-loading="loading">
    <!-- <div class="title">资产信息</div> -->
    <div class="div-top">
      <span style="margin-left: 10px">年月</span>
      <el-date-picker
        style="margin-left: 10px"
        v-model="searchData.iYearMonth"
        type="month"
        value-format="yyyyMM"
        placeholder="选择月"
      >
      </el-date-picker>
      <el-input
        v-model="searchData.Keyword"
        clearable
        placeholder="请输入资产名称/编码"
        style="width: 300px; margin-left: 10px"
      ></el-input>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >
      <el-button
        type="warning"
        @click="handleExport"
        style="margin-left: 10px"
        icon="el-icon-download"
        >导出数据</el-button
      >
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 40px)"
      >
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>
        <el-table-column
          label="折旧年月"
          align="center"
          prop="iYearMonth"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="资产编码"
          align="center"
          prop="AssetCode"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="资产名称"
          align="center"
          prop="AssetName"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="折旧金额"
          align="right"
          prop="DepreciationAmount"
          sortable
        >
          <template slot-scope="scope">
            {{ $tools.momenyFormat(scope.row.DepreciationAmount, 2) }}
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center" prop="Remark">
        </el-table-column>
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-row
          :gutter="20"
          style="
            width: 400px;
            text-align: center;
            font-weight: bold;
            margin-top: 10px;
          "
        >
          <el-col>
            <div>{{ fun(this.totalData.DepreciationAmount) }}</div>
          </el-col>
        </el-row>
        <el-pagination
          style="margin-top: 10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import tools from '@/utils/tools.js'
export default {
  data() {
    return {
      tools,
      searchData: {
        Condition: 'AssetCode',
        Keyword: '',
        iYearMonth: '',
      },
      tableData: [],
      totalData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {},
  components: {},
  methods: {
    handleExport() {
      tools.download(
        this.$rootUrl +
          `/AM/AM_AssetDepreciation/ExportDetailToExcel?AssetCode=${this.searchData.Keyword}&iYearMonth=${this.searchData.iYearMonth}&Type=${this.AssetTreeSeacrh}`,
        '资产折旧查询',
        '.xlsx',
        'get'
      )
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    //数量,金额保留两位小数
    fun(val) {
      return '折旧总金额：' + (Number(val) === 0 ? 0 : Number(val).toFixed(2))
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/AM/AM_AssetDepreciation/GetDepreciationDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'Id',
          SortType: 'Desc',
          Search: {
            ...this.searchData,
            Type: this.AssetTreeSeacrh || '',
          },
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.tableData = resJson.Data
            this.pagination.total = resJson.Total
            this.$nextTick(() => {
              if (this.$refs.table) {
                this.$refs.table.clearSelection()
              }
            })
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    GetSum() {
      this.loading = true
      this.$http
        .post('/AM/AM_AssetDepreciation/GetTotalData', {
          Search: this.searchData,
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.totalData = resJson.Data
          }
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      console.log(this.searchData.Keyword)
      this.getDataList()
      this.GetSum()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
      this.GetSum()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
      this.GetSum()
    },
  },
  mounted() {},
  created() {
    this.getDataList()
    this.GetSum()
  },
  computed: {
    ...mapState(['AssetTreeSeacrh']),
  },
  watch: {
    AssetTreeSeacrh() {
      this.handleSearch()
    },
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
